// Copied from https://git.hubteam.com/HubSpotProtected/subscription-sidebar-cards/blob/master/card-subscription-highlight-lib/static/js/utils/feedback.ts

// Safety wrapper around `window.hsFeedback`
// https://product.hubteam.com/docs/sales-payments-docs/fe_surveys.html#csat-survey-implementation
function getFeedbackInstance() {
  if ('hsFeedback' in window) {
    return window.hsFeedback;
  }
  return {
    loadSurvey: () => void 0
  };
}
export function loadCSATSurvey(id) {
  getFeedbackInstance().loadSurvey('CSAT', id);
}